module.exports = __webpack_public_path__ + "img/14.17c283b1.jpeg";